import { inputBasicAction } from '@/js/pages/entry/input-basic';
import { inputDetailAction } from '@/js/pages/entry/input-detail';
import { inputParticipantAction } from '@/js/pages/entry/participant/input';
import { Loader as MapLoader } from 'google-maps';
import modalMapHtml from '@/html/modal-map.html';
import Modal from '@/js/components/modal';

export const renderTabs = () => {
    let labels = $('<div />').addClass('labels')
    $('.tabs').prepend(labels)
    $('.tabs > section').each((_idx, _obj) => {
        let hl = $(_obj).find('> h2').text()
        let obj = $('<label />').text(hl)
        labels.append(obj)
        if ($(_obj).hasClass('active')) {
            obj.addClass('active')
        }
    })
    $('.tabs > .labels > label').on('click', e => {
        $('.tabs > section').removeClass('active')
        $('.tabs > .labels > label').removeClass('active')
        let idx = $('.tabs > .labels > label').index(e.currentTarget)
        $(e.currentTarget).addClass('active')
        $('.tabs > section').eq(idx).addClass('active')
    })
}

export const replaceMapFrame = (mapKey) => {
    let lat = $('input[name="lat"]').val()
    let lng = $('input[name="lng"]').val()
    if (lat && lng) {
        let src = `https://www.google.com/maps/embed/v1/place?key=${mapKey}&q=${lat},${lng}`
        $('#map-frame iframe').attr('src', src)
    }
}

// googleMaps処理
export const setGoogleMaps = async (mapKey) => {
    const modal = new Modal({
        overlayClose: false,
    })
    const mapLoader = new MapLoader(mapKey)
    const google = await mapLoader.load()

    const getAddres2Location = async (address) => {
        let geocoder = new google.maps.Geocoder()
        return new Promise((resolve, reject) => {
            let res = geocoder.geocode({
                address,
                region: 'jp'
            },
                (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        resolve(results[0].geometry.location)
                    } else {
                        reject()
                    }
                }
            )
        })
    }

    $('#get-location').on('click', async () => {

        modal.setHtml(modalMapHtml).show()

        let lat = document.querySelector('input[name="lat"]').value
        let lng = document.querySelector('input[name="lng"]').value
        lat = lat ? lat : 35.689634
        lng = lng ? lng : 139.692101
        let location = new google.maps.LatLng(lat, lng)

        const map = new google.maps.Map(document.querySelector('#modal-map .map'), {
            center: location,
            zoom: 16,
        })
        let marker = new google.maps.Marker({
            position: location,
            //ドラッグを許可
            draggable: true,
            map: map,
        })

        google.maps.event.addListener(marker, 'dragend', function (e) {
            document.getElementById("modal_lat").value = e.latLng.lat()
            document.getElementById("modal_lng").value = e.latLng.lng()
        });

        document.querySelector('#modal-map button.submit').addEventListener('click', () => {
            document.querySelector('input[name="lat"]').value = document.getElementById("modal_lat").value
            document.querySelector('input[name="lng"]').value = document.getElementById("modal_lng").value
            replaceMapFrame(mapKey)
            modal.close()
        })

        document.querySelector('#modal-map button.address').addEventListener('click', async () => {
            let prefName = $('select[name="prefecture"] option:selected').text()
            let address = prefName + $('input[name="address_after"]').val()
            if (!window.confirm(`住所「${address}」に移動します。よろしいですか？`)) {
                return false
            }
            let location = await getAddres2Location(address)
            map.panTo(location)
            marker.setPosition(location)
            document.getElementById("modal_lat").value = location.lat()
            document.getElementById("modal_lng").value = location.lng()
        })
        document.getElementById("modal_lat").value = lat
        document.getElementById("modal_lng").value = lng

        return false
    })
}

// ランチの確保テーブル数に連動してランチ価格を有効/無効切り替え
export const setLunchEnableChange = () => {
    $('input[name="save_seat_lunch"]').on('blur', (e) => {
        if ($(e.currentTarget).val()) {
            $('input[name="price_lunch"]').prop('disabled', false)
            $('.item.price_lunch .input-check-container').find('.hide').remove()
        } else {
            let inputObj = $('<input />', {
                name: 'price_lunch',
                type: 'radio',
                value: '',
                class: 'hide',
                checked: 'checked'
            }).prop('checked', true)
            $('input[name="price_lunch"]').prop('disabled', true).prop('checked', false)
            $('.item.price_lunch .input-check-container').append(inputObj)
        }
    }).trigger('blur')
}

const main = () => {
    if (!document.querySelector('#page-entry-edit')) return;

    inputBasicAction();
    inputDetailAction();
    inputParticipantAction();

    const mapKey = document.querySelector('meta[name="map-key"]').getAttribute('content')


    renderTabs();

    const changeFormStage = () => {
        let url = new URL(window.location.href)
        let params = url.searchParams
        const formStage = params.get('form_stage')
        if (formStage) {
            $('.tabs > .labels > label').eq(Number(formStage) - 1).trigger('click')
        }
    }
    changeFormStage()

    $('input[name="lat"],input[name="lng"]').on('blur.mapreload', () => {
        replaceMapFrame(mapKey)
    })
    
    setGoogleMaps(mapKey)

    $('form#edit-entry').submit(e => {
        $('.area-submit button[type="submit"]').prop('disabled', true)
    })

    $('form#delete-entry').submit(() => {
        if (!window.confirm('この店舗のデータを削除します。本当によろしいですか？\n【辞退】の場合は削除ではなく【非公開】の設定にしてください。\n※削除したデータは元に戻せません。間違って登録した場合などを除き、基本的には削除しないでください。')) {
            return false
        }
        return true
    })

    setLunchEnableChange();
}

export default main;